import { compose, hoistStatics, lifecycle, withHandlers, withState, defaultProps } from 'recompose';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { toast } from 'react-toastify';

import Comments from './Comments';
import WithLoading from '../WithLoading';
import CommentsService from '../../services/comment.service';


const defaultCriteria = {
  page: 0,
  limit: 5,
  sortBy: 'created_at',
  order: 'desc',
};

const goToPage = props => async (nextPage, preload) => {
  const { criteria, setCriteria, setComments, setCount, model_id, model_name } = props;
  const page = nextPage > -1 ? nextPage : 0;
  const { data, count } = await CommentsService.getData({
    model_id,
    model_name,
    ...criteria,
    page });
  setComments(data);
  setCount(count);
  setCriteria({ ...criteria, page });
  const element = document.querySelector('#comments');
  if (!preload) {
    element.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  }
};

const submitComment = props => async (e, newMessage) => {
  e.preventDefault();
  const { model_id, model_name, t, upload_name, mulTempFiles } = props;
  const files = mulTempFiles[upload_name] || [];
  const filesIds = files.map(file => (file.id));
  const resp = await CommentsService.addComment({
    model_id,
    model_name,
    files: filesIds,
    ...newMessage });
  if (resp.comment) {
    await goToPage(props)(0);
    toast.success(t('Comment added'));
  }
  return resp;
};

const mapStateToProps = state => ({
  mulTempFiles: state.upload.mulTempFiles,
  user: state.user.user,
});

const enhance = compose(
  connect(mapStateToProps, null),
  translate('portal'),
  withState('isLoading', 'setIsLoading', true),
  withState('comments', 'setComments', []),
  withState('criteria', 'setCriteria', defaultCriteria),
  withState('count', 'setCount', 0),
  lifecycle({
    async componentDidMount() {
      const { setIsLoading } = this.props;
      if (this.props.user) {
        await goToPage(this.props)(0, true);
        setIsLoading(false);
      }
    },
    async shouldComponentUpdate(nextProps) {
      if (this.props.user && nextProps.model_id !== this.props.model_id) {
        const { setIsLoading } = this.props;
        await goToPage(nextProps)(0, true);
        setIsLoading(false);
      }
    },
  }),
  defaultProps({
    upload_name: 'comment',
  }),
  withHandlers({
    goToPage,
    submitComment,
  }),
);

export default withRouter(hoistStatics(enhance)(WithLoading(Comments, '')));



// WEBPACK FOOTER //
// ./src/components/comments/index.js